import { render, staticRenderFns } from "./selectBook.vue?vue&type=template&id=508dcafa&scoped=true"
import script from "./selectBook.vue?vue&type=script&lang=js"
export * from "./selectBook.vue?vue&type=script&lang=js"
import style0 from "./selectBook.vue?vue&type=style&index=0&id=508dcafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508dcafa",
  null
  
)

export default component.exports